import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=4c18e70a"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsTable.vue?vue&type=style&index=0&id=4c18e70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports